export function validateNRIC(str: any) {
  if (str.length !== 9) return false;

  str = str.toUpperCase();

  let i;
  const icArray: any[] = [];
  for (i = 0; i < 9; i++) {
    icArray[i] = str.charAt(i);
  }

  icArray[1] *= 2;
  icArray[2] *= 7;
  icArray[3] *= 6;
  icArray[4] *= 5;
  icArray[5] *= 4;
  icArray[6] *= 3;
  icArray[7] *= 2;

  let weight = 0;
  for (i = 1; i < 8; i++) {
    weight += parseInt(icArray[i], 10);
  }

  const offset =
    icArray[0] == 'T' || icArray[0] == 'G' ? 4 : icArray[0] == 'M' ? 3 : 0;
  let temp = (offset + weight) % 11;
  if (icArray[0] == 'M') temp = 10 - temp;

  const st = ['J', 'Z', 'I', 'H', 'G', 'F', 'E', 'D', 'C', 'B', 'A'];
  const fg = ['X', 'W', 'U', 'T', 'R', 'Q', 'P', 'N', 'M', 'L', 'K'];
  const m = ['K', 'L', 'J', 'N', 'P', 'Q', 'R', 'T', 'U', 'W', 'X'];

  let theAlpha;
  if (icArray[0] === 'S' || icArray[0] === 'T') {
    theAlpha = st[temp];
  } else if (icArray[0] === 'F' || icArray[0] === 'G') {
    theAlpha = fg[temp];
  } else if (icArray[0] == 'M') {
    theAlpha = m[temp];
  }

  return icArray[8] === theAlpha;
}

export function validateEmail(str: any) {
  const emailFormat = /^[a-zA-Z]+[a-zA-Z0-9_.]+@[a-zA-Z.]+[a-zA-Z]$/;

  return emailFormat.test(str);
}

export function validatePhone(str: any) {
  const phoneFormat = /^(?:\+65)?[689][0-9]{7}$/;

  return phoneFormat.test(str);
}

export function validatePostal(str: any) {
  const postalFormat = /^[0-9]{6}$/;

  return postalFormat.test(str);
}

export function validatePassport(str: any) {
  const passportFormat = /^[A-Z0-9]{1,9}$/;

  return passportFormat.test(str);
}

export function validateWhiteSpace(str: any) {
  if (typeof str !== 'string') {
    return false; // Return false if the input is not a string
  }

  if (str.includes(' ')) {
    return false; // Return false if the string contains white space
  }

  return true; // Return true if the string does not contain white space
}

export function validateCapitalLetter(str: any) {
  const upperCaseOnly = /[a-z]/;

  if (upperCaseOnly.test(str)) {
    return false;
  }

  return true;
}
